import { render, staticRenderFns } from "./HomeFoundationalReports.vue?vue&type=template&id=023a9d5a&scoped=true&"
import script from "./HomeFoundationalReports.vue?vue&type=script&lang=js&"
export * from "./HomeFoundationalReports.vue?vue&type=script&lang=js&"
import style0 from "./HomeFoundationalReports.vue?vue&type=style&index=0&id=023a9d5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023a9d5a",
  null
  
)

export default component.exports